// @ts-nocheck

import React, { useState, useEffect, useCallback, useRef } from 'react';

import ScrollingLabelsContext from '../contexts/ScrollingLabelsContext';

const ScrollingLabelProvider = (props) => {
  const { pauseDuration } = props;
  const [start, setStart] = useState(false);
  const [isFinishScroll, setIsFinishScroll] = useState(false);
  const timeout = useRef(null);
  const registeredLabels = useRef({}); // { [uniq id]: boolean isScrolling }

  const resetRegisteredLabelsValues = useCallback(() => {
    Object.keys(registeredLabels.current).forEach((id) => {
      registeredLabels.current[id] = false;
    });
  }, []);

  const checkRegisteredLabelsHasFinishScrolling = useCallback(() => {
    const allScrollsAreFinish =
      Object.keys(registeredLabels.current).filter((id) => registeredLabels.current[id] === false).length === 0;
    setIsFinishScroll((oldValue) => (allScrollsAreFinish && !oldValue) || oldValue);
  }, []);

  const sayConsumerScrollingIsFinish = useCallback(
    (id) => {
      registeredLabels.current[id] = true;
      checkRegisteredLabelsHasFinishScrolling();
    },
    [checkRegisteredLabelsHasFinishScrolling],
  );

  const register = useCallback((id) => {
    if (registeredLabels.current[id] === undefined) {
      registeredLabels.current[id] = false;
    }
  }, []);

  const dispose = useCallback((id) => {
    if (registeredLabels.current[id] !== undefined) {
      delete registeredLabels.current[id];
    }
  }, []);

  useEffect(() => {
    if (isFinishScroll) {
      resetRegisteredLabelsValues();
      setStart(false);
      timeout.current = setTimeout(() => {
        setIsFinishScroll(false);
        setStart(true);
      }, pauseDuration);
    }
    return () => {
      clearTimeout(timeout.current);
    };
  }, [pauseDuration, isFinishScroll, resetRegisteredLabelsValues]);

  useEffect(() => {
    resetRegisteredLabelsValues();
    timeout.current = setTimeout(() => {
      setStart(true);
    }, pauseDuration);
    return () => {
      clearTimeout(timeout.current);
    };
  }, [pauseDuration, resetRegisteredLabelsValues]);

  return (
    <ScrollingLabelsContext.Provider
      value={{
        start,
        register,
        dispose,
        sayConsumerScrollingIsFinish,
        pauseDuration,
      }}
    >
      {props.children}
    </ScrollingLabelsContext.Provider>
  );
};

export default ScrollingLabelProvider;
